import { ATTRIBUTE } from './attributes';

export const eventGroupsData = [
  "id",
  "timeline",
  "active",
  "created_on",
  "created_by",
  "type",
  "profile",
  "notes",
  "event_count",
  "parent",
  "images",
  "description",
  "risk_level",
  "status",
  "start",
  "end",
  "luke_index",
  "attributes",
  {
    name: "events",
    data: [
      "id",
      "active",
      "created_on",
      "created_by",
      "type",
      "profile",
      "zone",
      "event_count",
      "attributes",
      "notes",
      "images",
      "luke_index",
      "device",
      "parent_event_id",
      "group",
      "event_version",
      "reference_event_id",
      "verification",
    ],
  },
  {
    name: "event_groups",
    depth: 2
  }
];

export const COVID_VERIFICATION = "COVID_VERIFICATION";
export const VERIFICATION_OK = "VERIFICATION_OK";
export const VERIFICATION_WARNING = "VERIFICATION_WARNING";
export const VERIFICATION_THREAT = "VERIFICATION_THREAT";

export const EVENT_GROUP_TYPE = {
  RAILROAD_EVENT: 22,
  RAILCAR: 23
}

export const EVENT_GROUP_ATTR = {
  RAIL_DETECTION_TYPE: ATTRIBUTE.RAIL_DETECTION_TYPE,
  YARD_EVENT_TYPE: ATTRIBUTE.YARD_EVENT_TYPE,
  TRAIN_ID: ATTRIBUTE.TRAIN_ID
}

